import { OUTLOOK_CG_INTRO, OUTLOOK_CG_SLUG } from '@/content/outlookConsumerGoods'
import { outlook } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The twelfth report with a designed page of its own, and the third Future
  // 2030 outlook — asked for on 2026-08-28 in the same words as the
  // Manufacturing one (*"referans alarak ilgili sayfayı birebir tıpa tıp
  // aynısını tasarla"*) with a five-part full-page capture of the live page.
  // See `content/outlookConsumerGoods.ts` and `pages/OutlookConsumerGoods.tsx`.
  ...outlook(
    OUTLOOK_CG_SLUG,
    'Consumer Goods',
    undefined,
    'future-2030-outlook-consumer-goods-cover',
    '6a885abf-0e20-4c68-a87d-d072ebfa88fd-Digital Transformation Outlook Consumer Goods.pdf',
  ),
  // The hero's own two lines, joined into one paragraph — same as the two
  // outlook entries below, and for the same reason: this page draws its hero
  // from `OUTLOOK_CG_INTRO` directly, so `body` feeds exactly one thing, the
  // meta description `prerender.tsx` takes from `body[0]`.
  body: [`${OUTLOOK_CG_INTRO.lede} ${OUTLOOK_CG_INTRO.body}`],
  layout: 'consumer-goods-outlook',
  // Its own words and its file, so `stillToCome` has nothing left to say. What
  // it does *not* have is four of its six images — the files supplied with the
  // request were the Energy & Utilities outlook's — and that gap is carried
  // band by band by `outlookConsumerGoodsChecks()` rather than here, because it
  // is per-band rather than per-report.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 28
